import styled from 'styled-components';

export const StyledLevelReport = styled.div`
  .box {
    border-radius: 7px;
  }

  .spotlight-box {
    padding: 20px;
    font-family: Poppin, sans-serif;
    background-color: #ECEDF2;
    box-shadow: 0 3px 4px rgba(0, 0, 0, .2);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    
    @media screen and (max-width: 800px) {
      flex-direction: column;
      align-items: center;
    }
    
    h5 {
      margin-bottom: 13px;
      font-size: 1.5em;
      color: #B2B2B2;
      
      @media screen and (max-width: 800px) {
        margin-bottom: 5px;
      }
    }
    
    p {
      font-size: 1.5em;
      color: #707070;
    }
    
    * {
      margin: 0;
    }
    
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 230px;
      margin: 0 auto;
      
      @media screen and (max-width: 800px) {
        &:after {
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          background-color: #707070;
          max-width: 50px;
          margin: 15px auto;
        }
        
        &:last-child:after {
          display: none;
        }
      }
      
      @media screen and (max-width: 800px) {
        text-align: center;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      * {
        width: 100%;
      }
    }
  }
  
  .content {
    margin: 35px 0 10px 0;
    color: #2B2932;
    display: flex;
    justify-content: space-between;
    
    @media screen and (max-width: 1200px) {
      flex-direction: column;
      align-items: center;
    }
    
    h3 {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      font-size: 15px;
      margin-bottom: 10px;
    }
    
    p {
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5em;
      margin-right: 30px;
    }
  }
`;

export const PainelCampaignFuel = styled.div`
  border: 1px solid #ECEDF2;
  border-radius: 3px;
  box-shadow: 0 3px 4px rgba(0, 0, 0, .2);
  padding: 20px;
  max-width: 400px;
  
  svg.icon-gas-pump {
    margin-right: 5px;
  }
  
  @media screen and (max-width: 1200px) {
    flex-direction: column;
    justify-content: center;
    max-width: 600px;
  }
  
  img {
    display: inline-block;
  }
  
  h5 {
    font-size: 13px;
  }
  
  .chart {
    display: block;
    margin: 0 auto;
    
    .st0{fill: #FF171E;}
    .st1{fill: #00B43D;}
    .st2{fill: #FAED00;}
    .st3{fill: #FFCB00;}
    .st4{fill: #FF411A;}
    .st5{fill: #09D639;}
    .st6{fill: #FF7182;}
    .st8{font-size: 50px}
    .st9{fill: #34F96F;}
    .st10{fill: #919191;}
    .st11{font-size: 24px;}
    
    .seta {
        transform-origin: 248px 225px;
        transform: rotate(180deg);
        animation: 1s forwards animation-seta;
    }
    
    @keyframes animation-seta {
        0% {
            transform: rotate(180deg)
        }
        100% {
            transform: ${props => (props.rotate ? props.rotate : 'rotate(180deg)')};
        }
    }
  }
`;
